import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CreditInformationType } from '../state/types/credit-information.types';
import { KvkInformationType } from '../state/types/kvk-information.types';
import { BLService } from './bl.service';

@Injectable({
  providedIn: 'root',
})
export class CreditInformationService extends BLService {
  private RESOURCE_ENDPOINT = 'information-logistics/info/';

  getSwedishCreditInformation(corporateIdentity: string): Observable<CreditInformationType> {
    return this.httpGet<CreditInformationType & { error: string }>(this.RESOURCE_ENDPOINT + corporateIdentity).pipe(
      map((response) => {
        if (!response) {
          return null;
        }

        if (!Object.keys(response).length) {
          return null;
        }

        const { error, ...creditInformation } = response;
        if (error) {
          throw { error: { message: error } };
        }

        return creditInformation;
      }),
    );
  }

  getDutchCompanyInformation(kvkNumber: string): Observable<KvkInformationType> {
    return this.httpGet<KvkInformationType>(`${this.RESOURCE_ENDPOINT}kvk/${kvkNumber}`);
  }
}
